class KlaviyoBackInStock {
    constructor() {
      this.modal = document.querySelector('.modal--back-in-stock');
      this.form = this.modal.querySelector('.back-in-stock');
      this.errorWrapper = this.form.querySelector('.back-in-stock-error');
      this.successMessage = this.modal.querySelector('.back-in-stock-success');
      
      this.init();
    }
  
    init() {
      this.modal.addEventListener('click', this.handleModalClick.bind(this));
      this.form.addEventListener('submit', this.handleSubmit.bind(this));
    }
  
    handleModalClick(event) {
      if (!event.target.closest('.modal__content') || event.target.closest('[data-modal-close]')) {
        this.modal.classList.remove('modal--open');
      }
    }
  
    async handleSubmit(event) {
      event.preventDefault();
      const formData = Object.fromEntries(new FormData(this.form));
      
      try {
        const response = await this.submitBackInStockRequest(formData);
        
        if (response.status === 202) {
          this.handleSuccess(formData.email);
        } else {
          const data = await response.json();
          this.handleError(data);
        }
      } catch (error) {
        console.error('Submission error:', error);
        this.showError('An unexpected error occurred. Please try again.');
      }
    }
  
    async submitBackInStockRequest({ email, variant }) {
      return fetch(this.form.action, {
        method: 'POST',
        headers: {
          accept: 'application/vnd.api+json',
          revision: '2024-10-15',
          'content-type': 'application/vnd.api+json'
        },
        body: JSON.stringify({
          data: {
            type: 'back-in-stock-subscription',
            attributes: {
              profile: {
                data: {
                  type: 'profile',
                  attributes: { email }
                }
              },
              channels: ['EMAIL']
            },
            relationships: {
              variant: {
                data: {
                  type: 'catalog-variant',
                  id: `$shopify:::$default:::${variant}`
                }
              }
            }
          }
        })
      });
    }
  
    async subscribeToNewsletter(email) {
      try {
        await fetch('https://a.klaviyo.com/client/subscriptions?company_id=TuNDJV', {
          method: 'POST',
          headers: {
            revision: '2024-10-15',
            'content-type': 'application/vnd.api+json'
          },
          body: JSON.stringify({
            data: {
              type: 'subscription',
              attributes: {
                profile: {
                  data: {
                    type: 'profile',
                    attributes: { email }
                  }
                }
              },
              relationships: {
                list: {
                  data: {
                    type: 'list',
                    id: 'VH49PN'
                  }
                }
              }
            }
          })
        });
      } catch (error) {
        console.error('Newsletter subscription error:', error);
      }
    }
  
    handleSuccess(email) {
      this.form.style.display = 'none';
      this.successMessage.style.display = 'block';
      
      const shouldSubscribe = document.getElementById('jtw-subscribe-newsletter').checked;
      if (shouldSubscribe) {
        this.subscribeToNewsletter(email);
      }
    }
  
    handleError(response) {
      if (response?.errors?.[0]?.detail) {
        this.showError(response.errors[0].detail);
      }
    }
  
    showError(message) {
      this.errorWrapper.innerHTML = message;
      this.errorWrapper.classList.remove('hidden');
    }
  }
  
  new KlaviyoBackInStock();